const contentOutputs = {
  EDITABLE: 'editable',
  RENDERED: 'rendered',
  PLAIN_TEXT: 'plainText'
};
export default contentOutputs;